import seerat_1_channel from "../../../../assets/seerat/group_logo/seerat_1_channel.png";
import seerat_1_female from "../../../../assets/seerat/group_logo/seerat_1_female.png";
import seerat_1_male from "../../../../assets/seerat/group_logo/seerat_1_male.png";

import { faHand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ArabicGroupCard({ batch, gender, level }) {
  const links = {
    6: {
      male_0: "https://t.me/+AhwxT3A8Bek5YzJk",
      female_0: "https://t.me/+HO7D_gaM6PpiZTU8",

      male_1: "https://t.me/+fe5uoU-2ttk4NjVk",
      female_1: "https://t.me/+rK1BbC-JQi9lYjhk",
      channel_1: "https://t.me/+_sEYOb0cHOI2Zjhk",
    },
  };

  const getLink = (type) => {
    if (links[batch] && links[batch][type]) {
      return links[batch][type];
    } else {
      return "";
    }
  };
  const imageMap = {
    1: {
      male: seerat_1_male,
      female: seerat_1_female,
      channel: seerat_1_channel,
    },
  };
  if (links[batch])
    return (
      <div className="p-5 rounded bg-gradient-to-tl from-sky-300">
        <p>
          <span className="text-xl">Join </span>
          <FontAwesomeIcon className="text-blue-600" icon={faHand} fade />
        </p>

        <div className="mt-4 flex justify-around">
          <a
            href={getLink(`${gender}_${level}`)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <div>
                <img className="w-20" src={imageMap[level][gender]} alt="" />
              </div>
              <p className="text-center">Class Group</p>
            </div>
          </a>

          <a
            href={getLink(`channel_${level}`)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>
              <div>
                <img className="w-20" src={imageMap[level]["channel"]} alt="" />
              </div>
              <p className="text-center">Lecture Notes</p>
            </div>
          </a>
        </div>
      </div>
    );
}
